import { useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { onAnalyticsLogout, setAnalyticsUserId } from '../analytics/tracker';

/** Associates analytics events with the authenticated user and resets on logout. */
export const useAnalyticsAuthSync = (): void => {
  const { user, isAuthenticated } = useAuth();
  const wasAuthenticatedRef = useRef(isAuthenticated);

  useEffect(() => {
    if (isAuthenticated && user?.id) {
      setAnalyticsUserId(user.id);
    } else if (!isAuthenticated) {
      setAnalyticsUserId(null);
    }
  }, [isAuthenticated, user?.id]);

  useEffect(() => {
    if (wasAuthenticatedRef.current && !isAuthenticated) {
      onAnalyticsLogout();
    }
    wasAuthenticatedRef.current = isAuthenticated;
  }, [isAuthenticated]);
};
